//services
import resolve from "ioc/resolve";
import isFunction from "lodash/isFunction";
import ServiceBus from "servicestack/service-bus";
import _ from "underscore";
import open from "webmodals/open";
import sleep from "webutils/services/sleep";

//models
import DateFilter from "servicestack/auto-query/auto-query-date-filter.model";
import GroupByFilter from "servicestack/auto-query/auto-query-group-by-filter.model";
import Nav from "servicestack/auto-query/auto-query-nav.model";
import NumberFilter from "servicestack/auto-query/auto-query-number-filter.model";
import RadioFilter from "servicestack/auto-query/auto-query-radio-filter.model";
import TagFilter from "servicestack/auto-query/auto-query-tag-filter.model";
import TextFilter from "servicestack/auto-query/auto-query-text-filter.model";

//views
import filtersPromptTemplateUrl from "servicestack/auto-query/auto-query-filters-prompt.htm";

//configs
import $aqConfig from "servicestack/auto-query/auto-query.config";
import $pageConfig from "webutils/services/page-config";

const unwrap = (val) =>
  (isFunction(val) ? val(resolve("$session")) : val) || [];
const splitOnLast = (val, needle = "=") => {
  const lastIndex = val.lastIndexOf(needle);
  return [val.substr(0, lastIndex), val.substr(lastIndex + 1)];
};
export default class AutoQuery {
  constructor(options) {
    const $aq = this;
    // basicController($aq);
    let preOptions = {
      pageSizes: [6, 12, 24, 48, 72, 96],
      results: [],
      navs: [],
      filters: [],
      disableQueryString: true,
      append: false,
      calls: 0,
      total: 0,
      page: 1,
      criteria: {
        tagCriteria: {},
      },
      tagCriteria: {},
      sortOptions: {},
      debounce: 250,
      orderBy: "",
      pageSize: 24,
      appendPageSize: 96,
      groupSize: 0,
      $listeners: [],
      bus: new ServiceBus(),
      scrollTop: true,
    };
    let savedOptions = !options.disableSettingStorage
      ? $aq.getSavedOptions.call(options)
      : options;
    let postOptions = {
      append: savedOptions.append || options.append,
      orderBy: savedOptions.orderBy || options.orderBy,
      pageSize: savedOptions.pageSize || options.pageSize || options.take || 30,
      groupSize: savedOptions.groupSize || options.groupSize || 0,
    };

    const allProps = Object.assign(
      {},
      $aqConfig,
      preOptions,
      options,
      postOptions
    );
    Object.assign($aq, allProps);
    if (
      $aqConfig.hydrateTagCriteria ||
      Object.keys(allProps.tagCriteria || {}).length
    ) {
      // https://emun1.monday.com/boards/333027351/views/4635648/pulses/2273411477
      $aq.criteria.tagCriteria = $aq.getTagCriteria() || {};
    }

    $aq.onBeforeTagInit($aq, options);

    $aq.navs = unwrap(options.navs)
      .map((cf) => $aq.createNav(cf))
      .filter((m) => !!m);
    $aq.navs.forEach((nav, i) => {
      nav.index = i;
      nav.prev = i > 0 && $aq.navs[i - 1];
      nav.next = i < $aq.navs.length - 1 && $aq.navs[i + 1];
      i === 0 && nav.process(true);
    });
    $aq.filters = unwrap(options.filters)
      .map((cf) => $aq.createFilter(cf))
      .filter((m) => !!m);
    const $q = resolve("$q");
    Promise.all($aq.filters.map((f) => $q.when(f.$$initialized || 1))).then(
      () => {
        !allProps.disableQueryString && $aq.readQueryString();
        $aq.navs[0] && $aq.navs[0].process(true);

        $aq.onInitialized();
      }
    );
  }

  onBeforeTagInit() {
    const $aq = this;
  }

  createNav(config) {
    const $aq = this;
    if (!config) {
      return false;
    }
    if (config.disabled && config.disabled($aq, resolve("$session"))) {
      return false;
    }
    if (isFunction(config.hidden)) {
      config.hidden = config.hidden(resolve("$session"));
    }
    return new Nav(config, $aq);
  }

  createFilter(config) {
    const $aq = this;
    if (!config) {
      return false;
    }
    if (config.disabled && config.disabled($aq, resolve("$session"))) {
      return false;
    }
    if (isFunction(config.hidden)) {
      // console.warn("createFilter.hidden", config);
      config.hidden = config.hidden(resolve("$session"));
      // console.debug("createFilter.hidden", config.hidden, config);
    }
    if (config.groupBy) return new GroupByFilter(config, $aq);
    if (config.tag) return new TagFilter(config, $aq);
    if (config.number) return new NumberFilter(config, $aq);
    if (config.text) return new TextFilter(config, $aq);
    if (config.date) return new DateFilter(config, $aq);
    if (config.radio) return new RadioFilter(config, $aq);
  }

  onInitialized() {
    const $aq = this;
    const $rootScope = resolve("$rootScope");
    if (!$aq._initialized) {
      $aq.$listeners.push(
        $rootScope.$on("$onAuthenticated", $aq.load.bind($aq, true))
      );
      $aq.$listeners.push(
        $rootScope.$on("$onLogout", $aq.load.bind($aq, true))
      );
      if (!$aq.disableQueryString && $aq.retainQueryStringHistory) {
        $aq.$listeners.push(
          $rootScope.$on("$locationChangeSuccess", (e, newUrl, oldUrl) => {
            const newSplat = splitOnLast(newUrl, "=");
            const oldSplat = splitOnLast(oldUrl, "=");

            if (
              newSplat[0] === oldSplat[0] &&
              newSplat[1] !== oldSplat[1] &&
              newSplat[0].endsWith("page")
            ) {
              // console.debug("retainQueryStringHistory", {
              //   e,
              //   newSplat,
              //   oldSplat,
              // });
              if (!$aq.append && !$aq.isBusy()) {
                $aq.setPage(+newSplat[1]);
              }
            }
          })
        );
      }
    }
    // console.info(
    //   "onInitialized",
    //   "url: ",
    //   $aq.url,
    //   "page: ",
    //   $aq.page,
    //   "auto load: ",
    //   $aq.autoLoad,
    //   " :filters: ",
    //   $aq.filters.length,
    //   " :navs: ",
    //   $aq.navs.length,
    //   " : loadTrue: ",
    //   $aq.autoLoad ||
    //     ($aq.filters.length && $aq.filters.length > 0) ||
    //     ($aq.navs.length && $aq.navs.length > 0),
    //   $aq
    // );

    if ($aq.autoLoad === "FiltersOnly") {
      $aq.processFilters({ src: "onInitialized:FiltersOnly" });
    } else if (
      $aq.autoLoad ||
      ($aq.filters.length && $aq.filters.length > 0) ||
      ($aq.navs.length && $aq.navs.length > 0)
    ) {
      if ($aq.autoLoad === "FiltersAlways") {
        $aq.processFilters({ src: "onInitialized:FiltersAlways" });
      }
      $aq.load(true);
      //if ($aq.autoLoad) $aq.load(true);
    }
    $aq._initialized = new Date();
  }

  processFilters(args = {}) {
    const { initialWait = 1, incrementalWait = 10, request } = args;
    const $aq = this;
    const req = request || $aq.getRequest();
    // console.debug("$aq.processFilters", $aq.url, $aq.filters.length, {
    //   $src: args.src || args.op || args.source || args.origin,
    //   initialWait,
    //   incrementalWait,
    //   request,
    //   args,
    //   $aq,
    // });
    // chain filters, give some time to render
    return $aq.filters.reduce(
      (chain, g) =>
        g.process
          ? chain.finally(() => g.process(req)).then(sleep(incrementalWait))
          : chain,
      sleep(initialWait)
    );
  }

  getSavedOptions() {
    const $aq = this;
    return resolve("$localStorage")[$aq.url + ":AQ"] || {};
  }
  saveOptions() {
    const $aq = this;
    return (resolve("$localStorage")[$aq.url + ":AQ"] = {
      append: $aq.append,
      orderBy: $aq.orderBy,
      pageSize: $aq.pageSize,
      groupSize: $aq.groupSize,
    });
  }

  navigate(key, id) {
    const $aq = this;
    $aq.navs.forEach((g) => g.tagKind == key && g.select(id));
  }

  clear(key, value) {
    const $aq = this;
    $aq.total = 0;
    $aq.results = [];
    $aq.page = 1;
  }

  toggle(key, id, clear) {
    const $aq = this;
    if (clear) {
      $aq.clearRefinements();
      $aq.clearNavs();
    }
    $aq.filters.forEach(
      (g) => (g.tagKind == key || g.fieldName == key) && g.toggle(id)
    );
  }

  getRequest(clear) {
    let $aq = this;
    //if ($aq.loading) return false;
    let request = angular.merge(
      {
        $clear: !!clear,
        include: "Total",
        fields: $aq.fields,
        orderBy: $aq.orderBy,
        skip: clear && $aq.append ? 0 : ($aq.page - 1) * $aq.pageSize,
        take:
          clear && $aq.append && $aq.page
            ? $aq.page * $aq.pageSize
            : $aq.pageSize,
      },
      $aq.criteria
    );
    for (let k in request) {
      if (k.endsWith("In") && Array.isArray(request[k]) && request[k].length)
        request[k] = JSON.stringify(request[k]); //.join(',');
      if (request[k] === "") delete request[k];
    }

    // console.warn("$aq.$getRequest", $aq.url, request);
    return request;
  }

  load(clear, _token) {
    let $aq = this;
    // console.debug("$aq.$load", $aq.url, { clear, _token });
    let $timeout = resolve("$timeout");

    if ($aq.isBusy(_token)) {
      $timeout.cancel($aq._loadTimeout);
      // console.warn("$aq.$isBusy", $aq.url, {
      //   clear,
      //   _token,
      //   $tO: $aq._loadTimeout,
      // });
      let token = ($aq._loadTimeout = $timeout(
        () => $aq.load(clear, token),
        $aq.debounce
      )); // delay 250 ms
      return token;
    }

    if (clear && $aq.calls > 0) {
      $aq.page = 1;
    }

    //if ($aq.loading) return false;
    let request = $aq.getRequest(clear);
    const loadingArgs = {
      request,
      clear,
      calls: $aq.calls++,
    };
    // console.warn("$aq.load", $aq.url, loadingArgs);
    if (!$aq.onLoading(loadingArgs)) return false;
    $aq.beforeLoading(loadingArgs);

    $aq._busy = new Date();
    $aq._idle = false;
    return $aq.bus[$aq.httpMethod === "POST" ? "send" : "read"](
      $aq.url,
      request
    )
      .then(
        (response) => {
          $aq.scrub(response);
          let result = response.data;
          if (!$aq.append || clear) {
            Object.assign($aq, result);
          } else {
            $aq.results.push(...result.results);
            $aq.total = result.total;
          }
          $aq.setGroupSize($aq.groupSize);
          $aq.first = result.results[0];
          let args = Object.assign(
            {
              request,
              response,
              clear,
              calls: $aq.calls,
              count: result.results.length,
              first: result.results[0],
            },
            result
          );
          $aq.onLoaded && $aq.onLoaded(args, $aq);
          $aq.afterLoaded && $aq.afterLoaded(args, $aq);
          if (!result.results.length) {
            $aq.onEmpty(args, $aq);
          }
          $aq.afterProcessed && $aq.afterProcessed(args, $aq);
          return result;
        },
        (response) => {
          $aq.results = [];
          $aq.page = 1;
          $aq.onFailed({ request, response, clear, calls: $aq.calls });
          $aq._failed = new Date();
        }
      )
      .finally(() => {
        $aq._idle = new Date();
        $aq._busy = false;
        $aq._loadTimeout = false;
      });
  }

  onLoading(args) {
    let $aq = this;
    let $request = ($aq.$request = args.request);
    $request.tagCriteria = $aq.getTagCriteria();
    $aq.getRefinements();
    return $request;
  }
  beforeLoading(args) {}
  scrub(response) {}
  afterLoaded(args) {
    // console.debug("aq.afterLoaded", args, this);
  }
  afterProcessed(args) {
    // console.debug("aq.afterProcessed", args, this);
  }
  onLoaded(args) {
    let $aq = this;
    //console.debug("aq.onLoaded", $aq.url, { args, $aq });
    if (args.clear && (!$aq.hideLeftNav || $aq.filterPromptOpen)) {
      // console.debug("$aq.processFilters", $aq.url, { args, $aq });
      // https://emun1.monday.com/boards/333027351/views/4635648/pulses/4289098423
      $aq.processFilters({
        initialWait: 250,
        incrementalWait: 10,
        request: $aq.$request,
        src: "onLoaded",
      });
    }

    if ($aq.dontWrite) {
      delete $aq.dontWrite;
    } else {
      !$aq.disableQueryString && $aq.writeQueryString();
    }
  }
  getTagCriteria() {
    let $aq = this;
    let tagCriteria = Object.assign(
      {},
      $aq.tagCriteria,
      $aq.criteria.tagCriteria
    );
    for (let key in tagCriteria) {
      if (tagCriteria[key]) {
        if (!tagCriteria[key].length) {
          delete tagCriteria[key];
        } else if (!Array.isArray(tagCriteria[key])) {
          tagCriteria[key] = [tagCriteria[key]];
        }
      }
    }
    return Object.keys(tagCriteria).length ? tagCriteria : null;
  }
  toggleLeftNav() {
    let $aq = this;
    console.debug("aq.toggleLeftNav", $aq.url, $aq);
    if ($aq.hideLeftNav === "FiltersPrompt") {
      return $aq.showFiltersPrompt();
    }
    if (!($aq.hideLeftNav = !$aq.hideLeftNav)) {
      return $aq.processFilters({ src: "toggleLeftNav" });
    }
  }
  onEmpty() {}
  onFailed() {}
  isBusy(_token) {
    return (
      this.bus.activeCalls.length > 0 ||
      (this._loadTimeout && this._loadTimeout !== _token)
    );
  }
  isIdle(_token) {
    return !this.isBusy(_token);
  }
  isEmpty() {
    return this.bus.calls > 0 && this.isIdle() && this.total === 0;
  }
  dispose() {
    //console.debug("aq$destroy", this.$listeners, this);
    this.$listeners.forEach((l) => l());
    return this.bus.dispose();
  }
  getHeadlines() {
    const $aq = this;
    const results = [];
    $aq.navs.concat($aq.filters).forEach((f) => {
      if (f.headline) {
        const headlines = f.getRefinements ? f.getRefinements() : [];
        if (headlines.length > 0) {
          results.push(
            isFunction(f.headline)
              ? f.headline(headlines)
              : headlines.map((h) => h.label)
          );
        }
      }
    });
    $aq.tagPaginations = $aq.navs
      .concat($aq.filters)
      .filter((f) => f.pagination);
    $aq.onGotHeadlines(results);
    return ($aq.headlines = results);
  }
  onGotHeadlines(headlines) {
    // console.debug("onGotHeadlines", headlines);
  }
  getRefinements() {
    const $aq = this;
    $aq.getHeadlines();
    let results = [];
    $aq.filters.forEach(
      (f) =>
        (f.showRefinement || f.hidden !== true) &&
        results.push.apply(results, f.getRefinements ? f.getRefinements() : [])
    );
    $aq.onGotRefinements(results);
    return ($aq.refinements = results);
  }
  onGotRefinements(refinements) {}
  clearRefinements(load) {
    const $aq = this;
    //console.log("aq.clearRefinements!", load, $aq.filters);
    $aq.getRefinements().forEach((r) => r.remove());
    $aq.filters.forEach(
      (g) => !g.hidden && !g.preventClear && g.clear && g.clear()
    );
    return load && $aq.load(true);
  }
  clearNavs(load = true) {
    const $aq = this;
    $aq.navs.forEach((g) => g.clear(true));
    return load && $aq.load(true);
  }
  filter(field, value) {
    const $parse = resolve("$parse");
    for (let k in this.criteria)
      if (k.toLowerCase() == field.toLowerCase()) delete this.criteria[k];
    $parse(field).assign(this.criteria, value);
    this.load(true);
  }
  search(value) {
    const $aq = this;
    for (let k in $aq.criteria)
      if (k.toLowerCase() == "search") delete $aq.criteria[k];
    if (value && $aq.orderByOnSearch) {
      $aq.orderBy = $aq.orderByOnSearch;
    }
    $aq.filter("Search", value);
  }
  sort(orderBy) {
    const $aq = this;
    $aq.orderBy = orderBy;
    $aq.load(true);
    $aq.saveOptions();
  }
  setView(view) {
    this.view = view;
  }
  setOrderBy(orderBy) {
    this.sort(orderBy);
  }
  groupResults(groupSize) {
    return _.groupBy(this.results, (val, index) =>
      Math.floor(index / groupSize)
    );
  }
  hasMore() {
    const $aq = this;
    return $aq.results.length < $aq.total;
  }
  more() {
    const $aq = this;
    // console.debug('aq.more', 'page:', $aq.page, 'page:', $aq.offset, 'total:', $aq.total, 'results.length:', $aq.results.length);
    if ($aq.append && !$aq.isBusy() && $aq.hasMore()) {
      // console.info('aq.more', $aq);
      $aq.setPage(1 + $aq.page);
    }
  }
  setPageSize(pageSize, force) {
    const $aq = this;
    if (pageSize == $aq.pageSize && !force) return;
    $aq.pageSize = pageSize;
    $aq.append = false;
    $aq.page = 1;
    if ($aq.scrollTop) {
      $pageConfig.goTop();
    }
    $aq.load(true);
    $aq.saveOptions();
  }
  setAppend(append) {
    const $aq = this;
    if (append === $aq.append) return;
    $aq.append = !!append;
    $aq.page = 1;
    $aq.append && ($aq.pageSize = $aq.appendPageSize);
    $aq.scrollTop && $pageConfig && $pageConfig.goTop();
    $aq.load(true);
    $aq.saveOptions();
  }
  setGroupSize(groupSize) {
    if ((this.groupSize = groupSize) > 0) {
      this.groupedResults = this.groupResults(this.groupSize);
    }
  }
  setPage(page) {
    const $aq = this;
    $aq.page = page;
    //always go to top when changing pages
    //    if ($aq.scrollTop) {
    !$aq.append && $pageConfig.goTop();
    //    }
    $aq.load(false);
  }
  resetPaging() {
    let $aq = this;
    $aq.results = [];
    $aq.page = 1;
    $aq.load(true || $aq.append);
  }
  pageInfo() {
    let $aq = this;
    if ($aq.isBusy()) return `Loading...`;
    if (!$aq.total) return "No results";
    if ($aq.append) return `${$aq.results.length} of ${$aq.total}`;
    let begin = ($aq.page - 1) * $aq.pageSize;
    let end = begin + $aq.pageSize;
    return `${begin + 1} - ${Math.min(end, $aq.total)} of ${$aq.total}`;
  }
  productCount() {
    let $aq = this;
    return `of ${$aq.total}`;
  }
  pageCount() {
    let $aq = this;
    return !$aq.append && Math.ceil($aq.total / $aq.pageSize);
  }
  readQueryString(reset) {
    const $aq = this;
    const $location = resolve("$location");
    const $stateParams = resolve("$stateParams");
    let params = ($aq.initialParams = Object.assign(
      {},
      $stateParams,
      $location.search()
    ));
    // console.warn("readQueryString", reset, {
    //   params,
    //   $stateParams,
    //   qs: $location.search(),
    //   absUrl: $location.absUrl(),
    // });
    if (params.tagCriteria) {
      $aq.tagCriteria = {}; // why?
      let tagCriteria = JSON.parse(params.tagCriteria);
      for (var kind in tagCriteria)
        params[kind] = decodeURIComponent(tagCriteria[kind]);
      delete params.tagCriteria;
    }
    if (params.clear) {
      params = {};
    } else if (Object.keys(params).length === 0) {
      //  params = $localStorage.productBrowserParameters;
    }

    if (reset) {
      $aq.dontWrite = true;
      $aq.page = 1;
      $aq.navs[0] && $aq.navs[0].process(true);
      $aq.navs.concat($aq.filters).forEach((f) => f.clear && f.clear());
    }
    Object.keys(params).forEach((fieldName) => {
      const value = params[fieldName] ? params[fieldName] : null;
      // console.debug("readQueryString", fieldName, value);
      switch (fieldName.toLowerCase()) {
        case "fields":
          $aq.fields = value;
          break;
        case "pagesize":
        case "take":
          $aq.take = parseInt(value);
          break;
        case "orderby":
        case "sortby":
          if (value) {
            $aq.orderBy = value;
          }
          break;
        case "page":
          $aq.page = parseInt(value);
          break;
        default:
          $aq.navs
            .concat($aq.filters)
            .forEach(
              (f) => f.readQueryString && f.readQueryString(fieldName, value)
            );
          break;
      }
    });
  }
  writeQueryString() {
    const $aq = this;
    const $location = resolve("$location");
    const $timeout = resolve("$timeout");

    if ($aq._wqsTimeout) {
      $timeout.cancel($aq._wqsTimeout);
      return ($aq._wqsTimeout = $timeout(() => $aq.writeQueryString(), 250)); // delay 250 ms
    }
    if ($aq.disableQueryString) return;

    let params = {};
    let context = $aq.context || $aq.criteria.context;
    ($aq.navs || [])
      .concat($aq.filters)
      .forEach((f) => f.writeQueryString && f.writeQueryString(params));
    if ($aq.orderBy) params.orderBy = $aq.orderBy;
    if (context) params.context = context;
    if ($aq.page) {
      params.page = $aq.page;
      // if ($aq.append) {
      //   params.take = $aq.page * $aq.pageSize;
      // }
    }
    $aq.dontRead = true;
    // console.warn("writeQueryString", params, $aq);
    $location.search(params);
    if (!$aq.retainQueryStringHistory) {
      $location.replace();
    }

    return params;
  }

  exportToCsv(name = "Data.csv") {
    const $aq = this;
    const request = {
      ...$aq.getRequest(),
      tagCriteria: $aq.getTagCriteria(),
      take: 5000,
      skip: 0,
    };
    const link = document.createElement("a");
    link.download = name;
    link.href = ServiceBus.getUrl($aq.url, request, ".csv");
    // console.debug("link.href", link.href);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  exportToExcel(template, origin, name = "Data.xlsx") {
    const $aq = this;
    // console.info("$aq.getTagCriteria()", $aq.getTagCriteria());
    const request = {
      ...$aq.getRequest(),
      tagCriteria: JSON.stringify(
        $aq.getTagCriteria() == null ? undefined : $aq.getTagCriteria()
      ),
      Template: template,
      Origin: origin,
      take: 25000,
      skip: 0,
    };
    const link = document.createElement("a");
    link.download = name;
    link.href = ServiceBus.getUrl($aq.url, request, ".xlsx");
    // console.debug("link.href", link.href);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  showFiltersPrompt({
    size = $aqConfig.filterPromptDefaults.size,
    backdrop = $aqConfig.filterPromptDefaults.back,
    placement = $aqConfig.filterPromptDefaults.placement,
    preventAutoHeight = $aqConfig.filterPromptDefaults.preventAutoHeight,
    title = ` `,
    subTitle = null,
    ...others
  } = {}) {
    const query = this;
    query.filterPromptOpen = new Date().getTime();
    const prompt = open({
      size,
      backdrop,
      templateUrl: filtersPromptTemplateUrl,
      placement,
      controller() {
        query.filters.reduce(
          (chain, g) =>
            g.process
              ? chain.then(() => g.process(query.$request)).then(sleep(10))
              : chain,
          sleep(10)
        );
        Object.assign(
          this,
          {
            query,
            subTitle,
            title,
            preventAutoHeight,
          },
          others
        );
        // console.debug("filter prompt", this);
      },
      bindToController: true,
      controllerAs: "$ctrl",
    }).result;
    prompt.finally(() => {
      console.debug("aq.filterPromptOpen", query.filterPromptOpen);
      delete query.filterPromptOpen;
    });
    return prompt;
  }

  linkDirective(scope, attr) {
    let $aq = this;
    attr.onLoading &&
      $aq.loading.subscribe((args) => $parse(attr.onLoading)(scope, args));
    attr.onLoaded &&
      $aq.loaded.subscribe((args) => $parse(attr.onLoaded)(scope, args));
    attr.onEmpty &&
      $aq.empty.subscribe((args) => $parse(attr.onEmpty)(scope, args));
    attr.onFailed &&
      $aq.failed.subscribe((args) => $parse(attr.onFailed)(scope, args));
    attr.first &&
      $aq.loaded.subscribe((args) =>
        $parse(attr.first).assign(scope, args.results[0])
      );
    attr.last &&
      $aq.loaded.subscribe((args) =>
        $parse(attr.last).assign(scope, args.results[args.results.length - 1])
      );
    attr.ngModel && $parse(attr.ngModel).assign(scope, $aq);
  }
}
